import type {Components} from '@mui/material';
import type {Variant} from '@mui/material/styles/createTypography';
import type {TypographyCustomVariants} from '../system/typography';

type MuiTypographyType = Omit<Components['MuiTypography'], 'defaultProps'> & {
  defaultProps: NonNullable<Components['MuiTypography']>['defaultProps'] & {
    variantMapping: Record<TypographyCustomVariants | Variant, string>;
  };
};

export const MuiTypography: MuiTypographyType = {
  defaultProps: {
    variant: 'BodyRegular',
    variantMapping: {
      h1: 'h1',
      h2: 'h2',
      h3: 'h3',
      h4: 'h4',
      h5: 'h5',
      h6: 'h6',
      subtitle1: 'h6',
      subtitle2: 'h6',
      body1: 'p',
      body2: 'p',
      inherit: 'p',
      caption: 'span',
      button: 'span',
      overline: 'span',
      CaptionSmallRegular: 'span',
      CaptionSmallMedium: 'span',
      CaptionSmallStrong: 'span',
      CaptionSmallHeavy: 'span',
      CaptionRegular: 'span',
      CaptionMedium: 'span',
      CaptionStrong: 'span',
      CaptionHeavy: 'span',
      BodyLight: 'p',
      BodyRegular: 'p',
      BodyMedium: 'h6',
      BodyMedium_1: 'span',
      BodyStrong: 'p',
      BodyHeavy: 'p',
      BodyLargeLight: 'p',
      BodyLargeRegular: 'p',
      BodyLargeMedium: 'h6',
      BodyLargeMedium_1: 'span',
      BodyLargeStrong: 'h6',
      BodyLargeHeavy: 'p',
      HeadlineLight: 'p',
      HeadlineRegular: 'p',
      HeadlineMedium: 'p',
      HeadlineStrong: 'h5',
      HeadlineHeavy: 'p',
      TitleLight: 'p',
      TitleRegular: 'p',
      TitleMedium: 'p',
      TitleStrong: 'h4',
      TitleHeavy: 'p',
      DisplayLight: 'p',
      DisplayRegular: 'p',
      DisplayMedium: 'h3',
      DisplayStrong: 'h2',
      DisplayHeavy: 'h1',
    },
  },
};
